import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

export const preregisterationForm = createAsyncThunk(
  "preRegister/submit",
  async (data, { rejectWithValue }) => {
    try {
      const response = await agent.post(API.PRE_REGISTER, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const preRegistrationFormSlice = createSlice({
  name: "preRegistrationForm",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(preregisterationForm.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(preregisterationForm.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(preregisterationForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error";
      });
  },
});

export default preRegistrationFormSlice.reducer;
